<template>
  <section class="hero">
    <div class="hero-body">
      <div class="container">
        <h1 class="title">
          {{ title }}
        </h1>
        <h2 class="subtitle">
          {{ subtitle }}
        </h2>
        <h2 class="subtitle">
          <a class="button is-light" @click="onReloadClick">Ricarica</a>
        </h2>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  props: {
    error: {
      type: Object,
      default: () => ({ statusCode: 500})
    }
  },
  computed: {
    title() {
      return this.$t(`error.title.${this.error.statusCode}`)
    },
    subtitle() {
      return this.$t(`error.subtitle.${this.error.statusCode}`)
    }
  },
  methods: {
    onReloadClick() {
      this.$router.go()
    }
  }
}
</script>
